import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { HiddenCost } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface HiddenCostsProps {
    data?: HiddenCost[];
    style?: CSSProperties;
}

export const HiddenCosts: FC<HiddenCostsProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                Hidden costs and total cost of ownership
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column title="Hidden Costs" dataIndex="cost" width={334} />
                <Column title="Estimated Range" dataIndex="range" width={334} />
                <Column title="Examples" dataIndex="example" />
            </Table>
        </div>
    );
};
